function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.9145 0C13.5891 0 15.7704 2.14393 15.7704 4.78344V9.94396H9.19357C8.72223 9.94396 8.34954 10.3103 8.34954 10.7735C8.34954 11.226 8.72223 11.6031 9.19357 11.6031H15.7704V16.7528C15.7704 19.3923 13.5891 21.547 10.8926 21.547H5.55438C2.86883 21.547 0.6875 19.4031 0.6875 16.7636V4.79422C0.6875 2.14393 2.87979 0 5.56534 0H10.9145ZM18.5071 7.05687C18.8303 6.72289 19.3582 6.72289 19.6814 7.0461L22.8273 10.1812C22.9889 10.3428 23.0751 10.5475 23.0751 10.7737C23.0751 10.9892 22.9889 11.2047 22.8273 11.3555L19.6814 14.4906C19.5198 14.6522 19.3044 14.7384 19.0997 14.7384C18.8842 14.7384 18.6687 14.6522 18.5071 14.4906C18.1839 14.1674 18.1839 13.6395 18.5071 13.3163L20.2309 11.6033H15.7706V9.94418H20.2309L18.5071 8.23119C18.1839 7.90798 18.1839 7.38008 18.5071 7.05687Z",
    style: {
      fill: "white"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.544459d0.svg";
export { ForwardRef as ReactComponent };